module.exports = __webpack_public_path__ + "img/clip_image122.f297583c.png";